module.exports = __webpack_public_path__ + "img/logo.4c07b6d3.png";